"use client";

import React from "react";
import { Award, Shield, HeartHandshake, Lightbulb, Lock, BookOpen } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const valuesData = [{
  title: "Eccellenza",
  description: "Perseguiamo i più alti standard qualitativi in ogni aspetto della nostra professione, offrendo soluzioni legali impeccabili e su misura.",
  icon: Award
}, {
  title: "Integrità",
  description: "Operiamo con assoluta trasparenza e rettitudine, costruendo rapporti di fiducia duraturi e solidi con i nostri assistiti.",
  icon: Shield
}, {
  title: "Dedizione",
  description: "Ci immergiamo profondamente nelle sfide dei nostri clienti, garantendo un impegno costante e una presenza rassicurante.",
  icon: HeartHandshake
}, {
  title: "Innovazione",
  description: "Adottiamo un approccio moderno e proattivo, anticipando le evoluzioni normative per offrire concreti vantaggi competitivi.",
  icon: Lightbulb
}, {
  title: "Riservatezza",
  description: "Tuteliamo le informazioni dei nostri clienti con il massimo rigore, garantendo un ambiente sicuro e rigorosamente protetto.",
  icon: Lock
}, {
  title: "Competenza",
  description: "Il nostro team è composto da professionisti altamente qualificati, in costante aggiornamento sulle complesse dinamiche legali.",
  icon: BookOpen
}];
export default function Valori() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="valori" className="relative overflow-hidden py-[120px] !bg-[hsl(0,0%,0%)]">
      <style dangerouslySetInnerHTML={{
      __html: `
        .article-title, .article-preview-title {
          font-family: var(--font-sans) !important;
        }
      `
    }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[800px] h-[600px] bg-ring/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="text-ring text-sm font-medium tracking-widest uppercase mb-4 block">I Nostri Principi<br /><br /><br /><br /></span>
          <h2 className="article-title font-sans text-4xl mb-6 tracking-tight !text-[hsl(0,0%,100%)] md:text-5xl lg:text-6xl">I Nostri Valori<br /><br /></h2>
          <p className="text-muted-foreground text-lg md:text-xl leading-relaxed font-light">Lo Studio DCLegal, fondato dall’Avv. Giacomo Cardani dopo quasi vent’anni di esperienza come Legal &amp; Corporate Counsel in realtà italiane e multinazionali, offre assistenza legale specializzata in compliance, contrattualistica e corporate governance, con competenze consolidate anche in diritto penale d’impresa e diritto tributario. Lo Studio supporta società ed enti nella predisposizione di Modelli 231, nella redazione e revisione dei contratti, nell’implementazione di modelli privacy by design e nella gestione dei sistemi di intelligenza artificiale, con particolare attenzione ai profili di governance e conformità normativa. I professionisti di DCLegal ricoprono incarichi di Presidente o componente di Organismi di Vigilanza e svolgono attività di Data Protection Officer (DPO), garantendo un supporto continuativo orientato alla prevenzione dei rischi e alla corretta gestione dei processi aziendali. DCLegal collabora stabilmente con Development Compliance Partners S.r.l., offrendo così un’assistenza integrata che comprende audit, verifiche tecnico-specialistiche (tra cui cybersecurity, NIS2 e DORA), supporto in materia di Salute e Sicurezza, Ambiente e Sicurezza Alimentare, oltre all’accompagnamento nei percorsi di certificazione ISO. L’obiettivo dello Studio è affiancare imprese, management e professionisti con un approccio multidisciplinare, offrendo soluzioni giuridiche concrete e strumenti efficaci per affrontare un contesto normativo in continua evoluzione.</p>
        </div>

        
      </div>
    </section>;
}
function ValueCard({
  value,
  index
}: {
  value: typeof valuesData[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const Icon = value.icon;
  return <div ref={ref} data-index={index} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${index * 100}ms`
  }}>
      <Card className="h-full bg-background/60 backdrop-blur-md border-border/40 shadow-sm hover:shadow-md hover:border-ring/30 transition-all duration-500 group flex flex-col">
        <CardHeader className="pb-4">
          <div className="w-12 h-12 rounded-full bg-ring/10 flex items-center justify-center mb-4 group-hover:bg-ring/20 transition-colors duration-500">
            <Icon className="w-5 h-5 text-ring" strokeWidth={1.5} />
          </div>
          <CardTitle className="article-preview-title font-sans text-2xl text-foreground group-hover:text-ring transition-colors duration-300">
            {value.title}
          </CardTitle>
        </CardHeader>
        <CardContent className="flex-grow">
          <p className="text-muted-foreground leading-relaxed font-light">
            {value.description}
          </p>
        </CardContent>
      </Card>
    </div>;
}